module.exports = __webpack_public_path__ + "static/img/13.1d255b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/eng/13.png
// module id = WQtY
// module chunks = 0